var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommitment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_289_496)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.43 31.3699C24.28 31.3699 24.14 31.3299 24.01 31.2399C23.8 31.0999 23.68 30.8699 23.68 30.6199C23.68 30.4699 23.67 30.3099 23.65 30.1499C23.56 29.4399 23.24 28.8199 22.7 28.2799C22.16 27.7399 21.49 27.3999 20.77 27.3099C20.65 27.2999 20.48 27.2899 20.32 27.2999C20.06 27.3199 19.82 27.2099 19.67 26.9999C19.52 26.7999 19.48 26.5299 19.56 26.2899C19.71 25.8799 19.93 25.5099 20.19 25.2099L21.73 23.2699C24.38 19.9599 29.75 15.9799 33.68 14.3999C34.52 14.0799 35.4 14.2699 36.01 14.8699C36.64 15.4999 36.83 16.3999 36.5 17.2199C34.92 21.1599 30.95 26.5199 27.64 29.1699L25.67 30.7499C25.3 31.0199 25 31.1899 24.7 31.3099C24.62 31.3499 24.52 31.3699 24.43 31.3699ZM21.54 25.9399C22.38 26.1599 23.13 26.5999 23.76 27.2299C24.39 27.8499 24.81 28.5699 25.02 29.3699L26.71 28.0099C29.85 25.4999 33.62 20.4099 35.11 16.6699C35.26 16.2999 35.05 16.0399 34.95 15.9499C34.88 15.8799 34.62 15.6599 34.22 15.8099C30.5 17.3099 25.41 21.0799 22.89 24.2199L21.54 25.9399Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.08 35.7501C17.33 35.7501 16.61 35.4501 16.07 34.9101C15.45 34.2901 15.15 33.4301 15.25 32.5501L15.52 30.0901C15.78 27.6501 17.78 25.8401 20.26 25.7901C20.45 25.7801 20.7 25.7901 20.93 25.8101C22.02 25.9501 22.99 26.4401 23.77 27.2201C24.54 27.9901 25 28.9101 25.14 29.9401C25.17 30.1601 25.19 30.4001 25.19 30.6101C25.19 31.9301 24.68 33.1601 23.76 34.0901C22.99 34.8501 22 35.3201 20.88 35.4601L18.41 35.7301C18.3 35.7401 18.19 35.7501 18.08 35.7501ZM20.45 27.3001C20.41 27.3001 20.36 27.3001 20.32 27.3001C18.81 27.3301 17.21 28.3601 17.01 30.2601L16.74 32.7201C16.69 33.1401 16.84 33.5501 17.13 33.8501C17.42 34.1401 17.83 34.2901 18.24 34.2401L20.7 33.9701C21.47 33.8701 22.16 33.5501 22.68 33.0301C23.32 32.3901 23.68 31.5301 23.68 30.6101C23.68 30.4601 23.67 30.3001 23.65 30.1401C23.56 29.4301 23.24 28.8101 22.7 28.2701C22.16 27.7301 21.49 27.3901 20.77 27.3001C20.69 27.3001 20.57 27.3001 20.45 27.3001Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.24 28.22C27.83 28.22 27.49 27.88 27.49 27.47C27.49 25.27 25.7 23.49 23.51 23.49C23.1 23.49 22.76 23.15 22.76 22.74C22.76 22.33 23.09 21.99 23.5 21.99C26.52 21.99 28.98 24.45 28.98 27.47C28.99 27.89 28.65 28.22 28.24 28.22Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.68 35.7299C28.75 35.7299 27.82 35.2899 26.93 34.3999C26.64 34.1099 26.64 33.6299 26.93 33.3399C27.22 33.0499 27.7 33.0499 27.99 33.3399C29.17 34.5199 30.18 34.5199 31.36 33.3399L34.32 30.3799C35.51 29.1899 35.51 28.1799 34.32 26.9999L33.58 26.2699C33.29 25.9799 33.28 25.4999 33.57 25.2099C33.86 24.9099 34.34 24.9099 34.63 25.1999L35.37 25.9299C37.15 27.7099 37.15 29.6599 35.37 31.4399L32.41 34.3999C31.54 35.2799 30.61 35.7299 29.68 35.7299Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.11 24.26C16.92 24.26 16.72 24.19 16.58 24.04C14.82 22.27 14.82 20.31 16.58 18.54L19.54 15.58C21.3 13.82 23.28 13.82 25.04 15.58L25.78 16.32C26.07 16.61 26.07 17.09 25.78 17.38C25.49 17.67 25.01 17.67 24.72 17.38L23.97 16.64C22.79 15.46 21.77 15.46 20.6 16.64L17.64 19.6C16.46 20.79 16.46 21.8 17.64 22.99C17.93 23.28 17.93 23.76 17.64 24.05C17.49 24.19 17.3 24.26 17.11 24.26Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.55 21.3C21.36 21.3 21.17 21.23 21.02 21.08C20.73 20.79 20.73 20.31 21.02 20.02L24.72 16.32C25.01 16.03 25.49 16.03 25.78 16.32C26.07 16.61 26.07 17.09 25.78 17.38L22.08 21.08C21.93 21.23 21.74 21.3 21.55 21.3Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.16 29.4299C30.97 29.4299 30.78 29.3599 30.63 29.2099C30.34 28.9199 30.34 28.4399 30.63 28.1499L33.59 25.1899C33.88 24.8999 34.36 24.8999 34.65 25.1899C34.94 25.4799 34.94 25.9599 34.65 26.2499L31.69 29.2099C31.55 29.3599 31.36 29.4299 31.16 29.4299Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_289_496",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_289_496"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_289_496",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommitment);
export default __webpack_public_path__ + "static/media/commitment.e82a8c6c509f0e76a7946a4d4c43c29b.svg";
export { ForwardRef as ReactComponent };